<template>
  <section-page
    title="Email Signature"
    description="Create a custom signature that we will append to the bottom of every email you send out of Forefront"
    is-short
  >
    <app-upgrade-required v-if="!hasEmailIntegrationAbility" is-centered/>

    <template v-else>
      <form-field-editor
        v-model="form.email_signature"
        type="signature"
      />

      <div class="flex flex-end">
        <button-default :async-click="saveSignature">Save Signature</button-default>
      </div>
    </template>
  </section-page>
</template>

<script>
import AppUpgradeRequired from "../../../components/app/AppUpgradeRequired.vue";

export default {
  name: "ProfileEmailSignature",
  components: { AppUpgradeRequired },
  data() {
    return {
      validationErrors: {},
      form: {
        id: null,
        email_signature: '',
      }
    }
  },
  created() {
    let user = this.$utils.clone(this.$store.getters.authUser);
    this.form.id = user.id;
    this.form.email_signature = user.email_signature;
  },
  computed: {
    hasEmailIntegrationAbility() {
      return this.$store.state.accounts.features.EmailIntegration
    },
  },
  methods: {
    saveSignature() {
      return this.$api.users.updateEmailSignature(this.form, this.validationErrors)
        .then(() => {
          this.$buefy.toast.open({
            message: "Email Signature was saved",
            type: 'is-success'
          });
        });
    }
  },
}
</script>
